/**
 * Labstep
 *
 * @module screens/ProtocolCollection/Edit/Right/Values
 * @desc Protocol Value Screens
 */

import ProtocolValueActionCreate from 'labstep-web/components/ProtocolValue/Action/Create';
import { ProtocolValueListContainer } from 'labstep-web/components/ProtocolValue/List';
import { ProtocolValueTable } from 'labstep-web/components/ProtocolValue/Table';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import { Flex } from 'labstep-web/core/Flex';
import { PremiumFeatureScreenGuard } from 'labstep-web/core/PremiumFeature/ScreenGuard';
import { ProtocolValue } from 'labstep-web/models/protocol-value.model';
import type React from 'react';
import type { IProtocolValueManagerProps } from './types';

export const ProtocolValueManager: React.FC<
  IProtocolValueManagerProps
> = ({ protocol, tableFormat }) => {
  const action = <ProtocolValueActionCreate protocol={protocol} />;

  const protocolValues = protocol.protocol_values.filter(
    (p) => !p.deleted_at && !p.variable_template_guid,
  );

  return (
    <PremiumFeatureScreenGuard premiumFeature="inventory" unstyled>
      {tableFormat && protocolValues.length === 0 ? (
        <CardEmptyState
          src="/img/empty-state/inventory.svg"
          action={action}
          explanation={`Add ${ProtocolValue.getHumanReadableEntityName(
            true,
          )} to keep track of the resources, amounts and specific batches / aliquots used.`}
        />
      ) : (
        <Flex grow>
          {tableFormat ? (
            <>
              {action}
              <ProtocolValueTable protocolValues={protocolValues} />
            </>
          ) : (
            <ProtocolValueListContainer protocol={protocol} />
          )}
        </Flex>
      )}
    </PremiumFeatureScreenGuard>
  );
};
